import React, { useState, useEffect } from 'react';
import './ProfessionalPage.css'; // Ensure we have access to styles

const InternetFlowAnimation = () => {
    const [step, setStep] = useState(0);

    // Automation sequence
    useEffect(() => {
        const timer = setInterval(() => {
            setStep((prev) => (prev + 1) % 5); // Cycle through 5 steps (0-4)
        }, 3000); // Change step every 3 seconds

        return () => clearInterval(timer);
    }, []);

    const getStepDetails = (currentStep) => {
        switch (currentStep) {
            case 0: return { label: "1. User types URL", desc: "User types 'google.com' and hits Enter." };
            case 1: return { label: "2. DNS Lookup", desc: "Browser asks DNS Server: 'What is the IP for google.com?' -> '142.250.190.46'" };
            case 2: return { label: "3. TCP Handshake", desc: "Client & Server establish a reliable connection (SYN, SYN-ACK, ACK)." };
            case 3: return { label: "4. HTTP Request", desc: "Browser sends GET request to the Server IP." };
            case 4: return { label: "5. Server Response", desc: "Server sends back HTML/CSS/JS. Browser renders the page." };
            default: return { label: "Idle", desc: "" };
        }
    };

    const info = getStepDetails(step);

    return (
        <div className="internet-animation-container">
            <div className="animation-stage">
                {/* Nodes */}
                <div className={`node client ${step >= 0 ? 'active' : ''}`}>
                    <span className="node-icon">💻</span>
                    <span className="node-label">You</span>
                </div>

                <div className={`node dns ${step === 1 ? 'active pulse' : ''}`}>
                    <span className="node-icon">📒</span>
                    <span className="node-label">DNS</span>
                </div>

                <div className={`node server ${step >= 2 ? 'active' : ''}`}>
                    <span className="node-icon">☁️</span>
                    <span className="node-label">Server</span>
                </div>

                {/* Packets/Arrows */}
                {/* Step 1: DNS Request */}
                <div className={`packet dns-packet ${step === 1 ? 'animate' : ''}`}>?</div>

                {/* Step 2: TCP Handshake */}
                <div className={`connection-line ${step === 2 ? 'connected' : ''}`}></div>
                <div className={`handshake-icon ${step === 2 ? 'visible' : ''}`}>🤝</div>

                {/* Step 3: HTTP Request (Client -> Server) */}
                <div className={`packet http-req ${step === 3 ? 'animate' : ''}`}>GET</div>

                {/* Step 4: HTTP Response (Server -> Client) */}
                <div className={`packet http-res ${step === 4 ? 'animate' : ''}`}>HTML</div>

            </div>

            <div className="animation-info">
                <h4>{info.label}</h4>
                <p>{info.desc}</p>
                <div className="step-indicators">
                    {[0, 1, 2, 3, 4].map(i => (
                        <div key={i} className={`step-dot ${step === i ? 'active' : ''}`} onClick={() => setStep(i)} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default InternetFlowAnimation;
